'use strict';

import './index.scss';

import EventsMixin from '@pch/eventsjs';

import templatePolyfill from './template-polyfill';



templatePolyfill();


/**
 * @class
 * @classdesc The Displayable is a displayable thing,
 * like a lightbox, which can be given to a DisplayQueue
 * 
 * @mixes EventsMixin
 * 
 * @see DisplayQueue
 */
class Displayable {
    constructor({
            order = 1,
            closeHandle = '[data-displayable-close]',
            tmplElement,
            timeout = 0,
            offsetElement = document.body
        } = {}) {

        this.order = order;
        this.closeHandle = closeHandle;
        this.tmplElement = tmplElement;
        this.timeout = timeout;
        this.content = null;
        this.overlay = null;
        this.offsetElement = offsetElement;
        this.eventApi = tmplElement.dataset['displayableMarkEvent'];
        this.stayOpen = tmplElement.dataset.hasOwnProperty('displayableStayOpen');

        Object.assign(this, EventsMixin, {
            EVENTS: {
                OPEN: 'onOpen',
                CLOSE: 'onClose'
            }
        });

    }
    open() {

        if(!this.content) {
            const fragment = document.importNode(this.tmplElement.content, true);
            this.offsetElement.appendChild(fragment);

            this.content = this.offsetElement.children[this.offsetElement.children.length - 1];
            const possibleOverlay = this.offsetElement.children[this.offsetElement.children.length - 2];
            if(possibleOverlay.classList.contains('c-overlay')) {
                this.overlay = this.offsetElement.children[this.offsetElement.children.length - 2];
            }
            

            const closeHandles = Array.from(this.content.querySelectorAll(this.closeHandle));
            closeHandles.forEach(closeHandle => closeHandle.addEventListener('click', this.close.bind(this)));

            if(this.timeout) {
                setTimeout(this.close.bind(this), this.timeout);
            }

            this.fireEvent(this.EVENTS.OPEN);
        }

    }
    close(e) {
        
        if(this.content) {

            this.fireEvent(this.EVENTS.CLOSE, e);

            if(!this.stayOpen) {
                this.content.parentNode.removeChild(this.content);
                this.content = null;

                if(this.overlay) {
                    this.overlay.parentNode.removeChild(this.overlay);
                    this.overlay = null;
                }
            }
            
            this.markEvent();
        }

    }
    toggle() {
        if(!this.content) {
            this.open();
        } else {
            this.close();
        }
    }

    promise() {
        return new Promise((resolve, reject) => {
            this.open();

            this.addEventListener(this.EVENTS.CLOSE, e => {
                resolve(this);
            });            
        }); 
    }

    markEvent() {
        if(this.eventApi) {
            fetch(this.eventApi, {
                method: 'GET',
                credentials: 'same-origin'
            })
            .then(res => res.ok)
            .catch(error => console.error('Error:', error));
            
        }
    }

    static comparator(d1, d2) {
        try {
            let d1Order = parseInt(d1.order);
            let d2Order = parseInt(d2.order);

            if(d1Order && d2Order) {
                if(d1Order < d2Order) return -1;
                if(d1Order > d2Order) return 1;
                return 0;
            } else {
                return 0;
            }
        } catch(error) {
            return 0;
        }
    }
}

export default Displayable;
